var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.4297H13L8.54999 21.3897C7.88999 21.8297 7 21.3597 7 20.5597V18.4297C4 18.4297 2 16.4297 2 13.4297V7.42969C2 4.42969 4 2.42969 7 2.42969H17C20 2.42969 22 4.42969 22 7.42969V13.4297C22 16.4297 20 18.4297 17 18.4297Z",
    fill: "#EDDFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 12.1104C11.5901 12.1104 11.2501 11.7704 11.2501 11.3604V11.1504C11.2501 9.99039 12.1 9.42038 12.42 9.20038C12.79 8.95038 12.91 8.78039 12.91 8.52039C12.91 8.02039 12.5001 7.61035 12.0001 7.61035C11.5001 7.61035 11.0901 8.02039 11.0901 8.52039C11.0901 8.93039 10.7501 9.27039 10.3401 9.27039C9.93009 9.27039 9.59009 8.93039 9.59009 8.52039C9.59009 7.19039 10.6701 6.11035 12.0001 6.11035C13.3301 6.11035 14.41 7.19039 14.41 8.52039C14.41 9.66039 13.5701 10.2304 13.2601 10.4404C12.8701 10.7004 12.7501 10.8704 12.7501 11.1504V11.3604C12.7501 11.7804 12.4101 12.1104 12.0001 12.1104Z",
    fill: "#A461D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5996C12.1339 13.5996 12.25 13.7158 12.25 13.8496C12.25 13.9878 12.1395 14.0996 12 14.0996C11.8605 14.0996 11.75 13.9878 11.75 13.8496C11.75 13.7158 11.8661 13.5996 12 13.5996Z",
    fill: "#A461D8",
    stroke: "#A461D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.e44bea8adc18f7c6862b94a18afe7d4a.svg";
export { ForwardRef as ReactComponent };